

function isImage(url) {
    return /\.(jpg|jpeg|png|gif)(\?.*)?$/i.test(url);
}

// Function to check if a URL points to a video
function isVideo(url) {
    return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
}

// Function to determine file type based on URL
export default function determineFileType(url) {
    if (isImage(url)) {
        return 'image';
    } else if (isVideo(url)) {
        return 'video';
    } else {
        return 'unknown';
    }
}